import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminextraescolares-grupos',
  templateUrl: './adminextraescolares-grupos.component.html',
  styleUrls: ['./adminextraescolares-grupos.component.scss']
})
export class AdminextraescolaresGruposComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminextraescolares-grupos/adminextraescolares-grupos.component.ts